import { atom } from 'recoil';
import { Period, type SerializedFilter } from '@enmon/commons/lib/enmon';

export type ResellersFilterType = Pick<SerializedFilter, 'customer' | 'depth' | 'page' | 'pageSize'> & {
  period: Period;
};

export const resellersFilter = atom<ResellersFilterType>({
  key: 'resellersFilter',
  default: {
    page: 1,
    pageSize: 20,
    period: Period.Last24months,
    depth: -1,
  },
});
